export default "__VITE_ASSET__DqqrwQgS__"